import { render } from "./PopperBody.vue?vue&type=template&id=685a67e6&scoped=true"
import script from "./PopperBody.vue?vue&type=script&lang=js"
export * from "./PopperBody.vue?vue&type=script&lang=js"

import "./PopperBody.vue?vue&type=style&index=0&id=685a67e6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685a67e6"]])

export default __exports__